<n-slide-window #slideWindow
    [visible]="windowVisible"
    [showMask]="false"
    [outClickHide]="true"
    [width]="isSimpleMode ? '6.08rem' : '8rem'"
    *ngIf="pageReady"
    (onHide)="close()">
    <n-header>
        <h1 [innerHTML]="i18nLabel.Resulttitle"></h1>
        <n-help-link key="taskProgress"></n-help-link>
    </n-header>
    <!-- 执行进度 -->
    <n-block [title]="taskData.displayName">
        <!-- 自定义的提示信息 -->
        <div class="customTip" *ngIf="customTip">
            <n-tip
                [type]="customTipType"
                [content]="customTip">
            </n-tip>
        </div>

        <n-lv>
            <n-lv-item [label]="i18nLabel.progressLab" [colspan]="2">
                <div class="interval-5">
                    <n-percent-bar
                        [showValue]="false"
                        width="57%"
                        [ceil]="true"
                        [value]="{
                            color: isSimpleMode ? taskBatchStr.simpleModeStatusColor[taskData.taskStatus] : taskBatchStr.statusColor[taskData.taskStatus],
                            value: taskData.progress || 0,
                            outOfMaxColor: '#7ADFA0'
                        }">
                    </n-percent-bar>
                    <svg class="icon"
                        [class.loading]="taskData.taskStatus === taskStatus.running || taskData.taskStatus === taskStatus.rollbacking || taskData.taskStatus === taskStatus.waiting">
                        <use [attr.xlink:href]="isSimpleMode ? taskBatchStr.simpleModeIcon[taskData.taskStatus] : taskBatchStr.icon[taskData.taskStatus]"></use>
                    </svg>
                    <span *ngIf="taskData.taskStatus === taskStatus.running || taskData.taskStatus === taskStatus.rollbacking">
                        {{taskData.progress}}%
                    </span>
                    <span *ngIf="!(taskData.taskStatus === taskStatus.running || taskData.taskStatus === taskStatus.rollbacking)">
                        {{taskBatchStr.statusText[taskData.taskStatus]}}
                    </span>
                </div>
            </n-lv-item>
            <n-lv-item>
                <p class="execute_info">{{resultTip}}</p>
            </n-lv-item>
        </n-lv>
    </n-block>
    <!-- 执行结果 -->
    <n-data-table #dt
        id="om_task_detail_table"
        style="height: 380px;margin-top: .2rem;"
        [config]="tableConfig"
        [columnDefs]="columnDefs"
        [rest]="dataRest">
        <ng-template nTemplate
            [meta]="{field: 'execStatus'}"
            let-col
            let-value="value"
            let-data="rowData">
            <div class="interval-5">
                <svg class="icon"
                    [class.loading]="data.execStatus === taskStatus.running || data.execStatus === taskStatus.rollbacking">
                    <use [attr.xlink:href]="isSimpleMode ? taskBatchStr.simpleModeIcon[data.execStatus] : taskBatchStr.icon[data.execStatus]"></use>
                </svg>
                <span *ngIf="data.execStatus === taskStatus.failed || data.execStatus === taskStatus.rollbackFailed"
                    class="linkText"
                    (click)="onShowErrorDetail(data)"
                    [innerHTML]="taskBatchStr.statusText[data.execStatus]">
                </span>
                <span *ngIf="!(data.execStatus === taskStatus.failed || data.execStatus === taskStatus.rollbackFailed)"
                    [innerHTML]="taskBatchStr.statusText[data.execStatus]">
                </span>
            </div>
        </ng-template>
    </n-data-table>
    <n-footer>
        <button nButton
            [label]="i18nLabel.closeBtn"
            (click)="windowVisible = false">
        </button>
    </n-footer>
</n-slide-window>
<app-task-error-detail *ngIf="errorData"
    [(show)]="showErrorDetail"
    [error]="errorData">
</app-task-error-detail>
